<template>
  <div id="app" class="columns is-centered">
    <div class="column is-half">
      <Header/>
      <div class="spacer">&nbsp;</div>
      <CounterDisplay
        :currentCount="currentValue"
        :startHours="formValues.startHours"
        :startMinutes="formValues.startMinutes"
      ></CounterDisplay>
      <CounterForm
        :formValues="formValues"
        @startTimeSet="updateStartTime"
        @tickValueUpdated="updateTickValue"
        @currencyChanged="changeCurrency"
        @frequencyChanged="changedFrequency"
      ></CounterForm>
      <ShareSheet :formValues="formValues"></ShareSheet>
      <router-view @formValuesChanged="changedFormValues"></router-view>
      <Footer/>
    </div>
  </div>
</template>

<script>
import Header from './components/Header';
import Footer from './components/Footer';
import CounterDisplay from './components/CounterDisplay';
import CounterForm from './components/CounterForm';
import ShareSheet from './components/ShareSheet';
import helpers from './utils/helpers';

export default {
	name: 'app',
	components: {
		Header,
		CounterDisplay,
		CounterForm,
		ShareSheet,
		Footer,
	},
	data: () => {
		let now = new Date();
		return {
			formValues: {
				tickValue: 9.19,
				currency: '€',
				frequency: 3600,
				startHours: 8,
				startMinutes: 0,
			},
			currentDate: now,
		};
	},
	computed: {
		currentValue() {
			// Start Time:
			let startTime = helpers.createTimeObjectFrom(this.formValues.startHours, this.formValues.startMinutes);
			// Diff
			let difference = this.currentDate.getTime() - startTime.getTime();

			let valuePerSecond = this.formValues.tickValue / this.formValues.frequency;
			let valueSoFar = valuePerSecond * (difference / 1000);
			return `${valueSoFar.toFixed(2)} ${this.formValues.currency}`;
		},
	},
	created() {
		this.updateTimer();
		setInterval(this.updateTimer, 100);
	},
	destroyed() {
		clearInterval(this.updateTimer);
	},
	methods: {
		updateTimer() {
			this.currentDate = new Date();
		},
		updateStartTime(newStartTime) {
			this.formValues.startHours = newStartTime.getHours();
			this.formValues.startMinutes = newStartTime.getMinutes();
		},
		updateTickValue(newTickValue) {
			this.formValues.tickValue = newTickValue;
		},
		changeCurrency(newCurrency) {
			this.formValues.currency = newCurrency;
		},
		changedFrequency(newFrequency) {
			this.formValues.frequency = newFrequency;
		},
		changedFormValues(newFormValues) {
			this.formValues = newFormValues;
		},
	},
};
</script>

<style>
</style>